(function () {
  'use strict';

  let angular = window.angular;

  ToolKitTemplateController.$inject = ['$translate', '$timeout', '$element'];

  angular.module('app').component('toolKitTemplateView', {
    template:'<div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span>{{$ctrl.toolkitTemplate.name}}</span></div><div class="modal-body paddingB0"><div class="table-responsive margin-top-10"><div class="col-xs-12 marginT5"><table ng-attr-id="tools-table" class="table table-hover no-wrap" style="width: 100%"><thead><tr><th></th><th></th></tr></thead></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button></div></div>',
    controller: ToolKitTemplateController,
    controllerAs: '$ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ToolKitTemplateController($translate, $timeout, $element) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.tools = vm.resolve.tools || [];
      vm.adminTools = vm.resolve.adminTools || [];
      vm.toolkitTemplate = vm.resolve.toolkitTemplate;

      initTools();
    };

    function initTools() {
      const toolsMap = new Map();

      vm.tools.forEach(function (tool) {
        const name = tool.name;

        if (!toolsMap.has(name)) {
          toolsMap.set(name, {
            ...tool,
            type: 'Manager',
          });
        }
      });

      vm.adminTools.forEach(function (tool) {
        const name = tool.name;

        if (toolsMap.has(name)) {
          toolsMap.get(name).type = 'Manager/Admin';
        } else {
          toolsMap.set(name, {
            ...tool,
            type: 'Admin',
          });
        }
      });

      const data = Array.from(toolsMap.values());

      const columns = [
        {
          data: 'name',
          title: $translate.instant('entities._all.name'),
          render: function (data, type, row) {
            return row.name;
          },
        },
        {
          data: 'type',
          title: $translate.instant('entities._all.type'),
          render: function (data, type, row) {
            return row.type;
          },
        },
      ];

      const dtOptions = {
        processing: true,
        searching: true,
        lengthChange: false,
        pageLength: 4,
        info: false,
        data: data,
        autoWidth: false,
        width: '50%',
        columns: columns,
      };

      $timeout(function () {
        const table = $element.find('#tools-table').DataTable(dtOptions);
        table.columns.adjust();
      });
    }
  }
})();
